import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationsEN from './en/en.json'
import translationsHE from './he/he.json'
import translationsES from './es/es.json'
import translationsJA from './ja/ja.json'
import translationsKR from './kr/kr.json'
import translationsAR from './ar/ar.json'

const resources = {
  en: {
    translation: translationsEN
  },
  he: {
    translation: translationsHE
  },
  es: {
    translation: translationsES
  },
  ja: {
    translation: translationsJA
  },
  ar: {
    translation: translationsAR
  },
  kr: {
    translation: translationsKR
  }
};

i18n
  .use(initReactI18next) 
  .init({
    resources,
    fallbackLng: 'en', 
    interpolation: {
      escapeValue: false 
    }
  });
  
  export default i18n;